var height_5 = $('#mini-1-section-5 .counter span').height();
var inView5 = false;

var child5_1 = height_5*2;
var child5_2 = height_5;
var child5_3 = 0;


$(document).ready(function() {

    /* 2 ----------------------------------------------------------- */

    if ($("#mini-2-section-2").length) {
        let owl_2 = $("#mini-2-section-2 .owl-carousel").owlCarousel({
            items: 1,
            nav: false,
            dots: false,
            loop: true,
            smartSpeed: 500,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            mouseDrag: false,
            touchDraw: false,
            responsive: {
                0: {
                    dots: true
                },
                1280: {
                    dots: false
                }
            }
        }).on('changed.owl.carousel', function(event) {
    
            let currentIndex = event.item.index;
            let owlIndex = $(this).find('.owl-item').eq(currentIndex).find('.item').data('owl')
    
            if (owlIndex == 1 || owlIndex == 2)
                $('#mini-2-section-2 .text-top .text:eq(0)').addClass('active');
            else {
                $('#mini-2-section-2 .text-top .text:eq(0)').find('.faded.in').addClass('out');
                $('#mini-2-section-2 .text-top .text:eq(0)').removeClass('active');
            }
        
            if (owlIndex == 3 || owlIndex == 4)
                $('#mini-2-section-2 .text-top .text:eq(1)').addClass('active');
            else {
                $('#mini-2-section-2 .text-top .text:eq(1)').find('.faded.in').addClass('out');
                $('#mini-2-section-2 .text-top .text:eq(1)').removeClass('active');
            }
        
            if (owlIndex == 5)
                $('#mini-2-section-2 .text-top .text:eq(2)').addClass('active');
            else {
                $('#mini-2-section-2 .text-top .text:eq(2)').find('.faded.in').addClass('out');
                $('#mini-2-section-2 .text-top .text:eq(2)').removeClass('active');
            }
    
            /* ----------- */
            if ($('#mini-2-section-2 .text-top .active').find('.faded').length > 0) {
                $('#mini-2-section-2 .text-top .active').find('.faded').addClass('in');
            }
            if ($('#mini-2-section-2 .text-top').find('.faded.in.out').length > 0) {
                setTimeout(() => {
                    $('#mini-2-section-2 .text-top').find('.faded.in.out').removeClass('in').removeClass('out');
                }, 500);
            }
            /* ----------- */
    
        });
    
        $("#mini-2-section-2").swipe({
            swipeLeft: function () {
                owl_2.trigger('next.owl.carousel');
            },
            swipeRight: function () {
                owl_2.trigger('prev.owl.carousel');
            }
        });
    
        $("#mini-2-section-2 .float-nav .owl-prev").on('click', function() {
            owl_2.trigger('prev.owl.carousel');
        });
        $("#mini-2-section-2 .float-nav .owl-next").on('click', function() {
            owl_2.trigger('next.owl.carousel');
        });
    }

    /* 10 ------------------------------------------------------------------------------- */

    if ($('#mini-1-section-10').length) {
        let owl_10 = $("#mini-1-section-10 .owl-carousel").owlCarousel({
            items: 1,
            nav: true,
            dots: false,
            loop: true,
            margin: 0,
            smartSpeed: 800,
            navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
            responsive: {
                0: {
                    margin: 10
                },
                1280: {
                    margin: 0
                }
            }
        }).on('changed.owl.carousel', function(event) {
            
            let currentIndex = event.item.index;
            let owlIndex = $(this).find('.owl-item').eq(currentIndex).find('.item').data('owl')
            
            $('#mini-1-section-10 .owl-toggle span').eq(owlIndex).addClass('active').siblings().removeClass('active');
            
        });
    
        $('#mini-1-section-10 .owl-toggle span').on('click', function() {
            let idx = $(this).index();
    
            owl_10.trigger('to.owl.carousel', idx)
        })
    }

    /* 13 ---------------------------------------------------------------------------------------- */

    if ($('#mini-1-section-13').length) {
        let owl_13 = $("#mini-1-section-13 .owl-carousel").owlCarousel({
            items: 1,
            nav: false,
            dots: true,
            loop: false,
            margin: 20,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                }
            }
        });
    }

});

function randomNumber(number) {
    let length = number.toString().length;
    let min = Math.pow(10, length - 1);
    let max = Math.pow(10, length) - 1;

    return Math.floor(Math.random() * (max - min + 1)) + min;
}

$(window).scroll(function () {

    /* 2 ------------------------------------------------------------------------------- */

    if ($('#mini-2-section-2 ').length) {
        $section2 = $('#mini-2-section-2 .video-bg');
    if(calculateScrollPercentage($section2) >= 50){
        if (!$section2.find('.aos-init').hasClass('aos-animate'))
            $section2.find('.aos-init').addClass('aos-animate');
    }
    else {
        if ($section2.find('.aos-init').hasClass('aos-animate'))
            $section2.find('.aos-init').removeClass('aos-animate');
    }
    }

    /* 3 ------------------------------------------------------------------------------- */

    if ($('#mini-1-section-3').length) {
        $section3 = $('#mini-1-section-3');
        if (visiblePercent($section3) > 40) {
            if (!$section3.find('.image-container').hasClass('aos-animate'))
                $section3.find('.image-container').addClass('aos-animate');

            setTimeout(() => {
                $section3.find('.cpu').css('top', '0');
                $section3.find('.texts').addClass('aos-animate');
            }, 1000);
        }
        else {
            if ($section3.find('.image-container').hasClass('aos-animate'))
                $section3.find('.image-container').removeClass('aos-animate');

            setTimeout(() => {
                $section3.find('.cpu').css('top', '80px');
                $section3.find('.texts').removeClass('aos-animate');
            }, 1000);
        }
    }
    
    /* 5 ---------------------------------------------------------------------------- */

    if ($('#mini-1-section-5').length) {
        $('#mini-1-section-5 .aos-init').each(function() {
            if (isElementInView($(this))) {
                $(this).addClass('aos-animate');
            }
            else {
                $(this).removeClass('aos-animate');
            }
        });
    
        $section5 = $('#mini-1-section-5 .custom-gutter-2');
        if (isElementInView($section5)) {
            if (!inView5) { 
                setTimeout(() => {
                    $('#mini-1-section-5 .counter div:nth-child(1)').css('top', `${child5_1-height_5}px`);
                    $('#mini-1-section-5 .counter div:nth-child(2)').css('top', `${child5_2-height_5}px`);
                    $('#mini-1-section-5 .counter div:nth-child(3)').css('top', `${child5_3-height_5}px`);
                }, 200);
                setTimeout(() => {
                    $('#mini-1-section-5 .counter div:nth-child(1)').css('top', `${child5_1-(height_5*2)}px`);
                    $('#mini-1-section-5 .counter div:nth-child(2)').css('top', `${child5_2-(height_5*2)}px`);
                    $('#mini-1-section-5 .counter div:nth-child(3)').css('top', `${child5_3-(height_5*2)}px`);
                }, 400);
    
                inView5 = true;
            }
        }
        else {
            if (inView5) {
                $('#mini-1-section-5 .counter div:nth-child(1)').css('top', `${child5_1}px`);
                $('#mini-1-section-5 .counter div:nth-child(2)').css('top', `${child5_2}px`);
                $('#mini-1-section-5 .counter div:nth-child(3)').css('top', `${child5_3}px`);
    
                inView5 = false;
            }
        }
    }

    /* 6 ------------------------------------------------------------------------ */

    if ($('#mini-1-section-6').length) {
        $section6 = $('#mini-1-section-6');

        if (visiblePercent($section6) > 0 && visiblePercent($section6) < 50) {
            $('#mini-1-section-6 .sticky .container:nth-child(1)').css('opacity', 1);
            $('#mini-1-section-6 .sticky .container:nth-child(2) img').css('transform', 'scale(1.5)');
        }
        else {
            $('#mini-1-section-6 .sticky .container:nth-child(1)').css('opacity', 0);
        }

        if (visiblePercent($section6) > 50 && visiblePercent($section6) < 75) {
            $('#mini-1-section-6 .sticky .container:nth-child(2)').css('opacity', 1);
            $('#mini-1-section-6 .sticky .container:nth-child(2) img').css('transform', 'scale(1)');
        }
        else {
            $('#mini-1-section-6 .sticky .container:nth-child(2)').css('opacity', 0);
        }

        if (visiblePercent($section6) > 75) {
            $('#mini-1-section-6 .sticky .container:nth-child(3)').css('opacity', 1);
        }
        else {
            $('#mini-1-section-6 .sticky .container:nth-child(3)').css('opacity', 0);
        }
    }
        
    /* 9 ------------------------------------------------------------------------ */

    if ($('#mini-1-section-9').length) {
        $section9 = $('#mini-1-section-9 .front');
        if (isElementInView($section9)) {
            $('#mini-1-section-9 .rear').css('transform', 'translateX(-50%) scale(1)');
        }
        else {
            $('#mini-1-section-9 .rear').css('transform', 'translateX(-50%) scale(.8)');
        }
    }
});

$('#mini-1-section-8 .clippy .clip-item').on('mouseover', function() {
    $(this).addClass('active').siblings().removeClass('active');
}).on('mouseleave', function() {
    $('#mini-1-section-8 .clippy .clip-item').removeClass('active');
    $('#mini-1-section-8 .clippy .clip-item:nth-child(1)').addClass('active');
});

$('#mini-2-section-2 #watch-vid').on('click', function() {

    let src = $("#mini-2-section-2 .absVideo source").attr("src");
    $(".floating-video video source").attr("src", src);
    $(".floating-video video")[0].load();

    $('.floating-video').show();

});

$('.floating-video .fv-close').on('click', function() {

    $(".floating-video video source").removeAttr("src",);
    $(".floating-video video")[0].load();

    $('.floating-video').hide();

});